import Vue from "vue";
import { get } from "@/utils";
import { _getCategoria } from "../utils/helpers";
import { ERROR_SOLICITUD, RECHAZADO } from "@/config/constants/step-constants";

const Facebook = {
  enable() {
    Vue.$log.info("fb enable");
    !(function(f, b, e, v) {
      if (f.fbq) return;
      const n = (f.fbq = function() {
        n.callMethod
          ? n.callMethod.apply(n, arguments)
          : n.queue.push(arguments);
      });
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = "2.0";
      n.queue = [];
      const t = b.createElement(e);
      t.async = !0;
      t.src = v;
      const s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(
      window,
      document,
      "script",
      "https://connect.facebook.net/en_US/fbevents.js"
    );
  },
  wait() {
    return !!window.fbq;
  },
  init() {
    window.fbq("init", "1649877658563488");
  },

  /**
   * Oferta Nomina
   */

  // Landing
  landing() {
    window.fbq("track", "PageView", {
      content_type: "Nominas OM",
      content_name: ""
    });
  },

  /**
   * Pasos del Camino 1 - Caja de Ahorro
   */
  // Oferta
  ofertaCuenta() {
    window.fbq("track", "ViewContent", {
      content_type: "Nominas OM",
      content_name: "oferta"
    });
  },
  // TYP
  graciasCajaAhorro() {
    window.fbq("track", "Purchase", {
      content_type: "Nominas OM",
      content_name: "thankyou"
    });
  },

  /**
   * Pasos del Camino 2 - Paquetes
   */
  // Oferta
  oferta(context) {
    window.fbq("track", "ViewContent", {
      content_type: "Nominas OM",
      content_name: _getCategoria(
        context.state.paquetesBeneficios.caracteristicas
      )
    });
  },
  paso1(context) {
    window.fbq("track", "Suscribe", {
      content_type: "Nominas OM",
      content_name: _getCategoria(
        context.state.paquetesBeneficios.caracteristicas
      )
    });
  },
  paso2(context) {
    window.fbq("track", "Lead", {
      content_type: "Nominas OM",
      content_name: _getCategoria(
        context.state.paquetesBeneficios.caracteristicas
      )
    });
  },
  paso3(context) {
    window.fbq("track", "AddToCart", {
      content_type: "Nominas OM",
      content_name: _getCategoria(
        context.state.paquetesBeneficios.caracteristicas
      )
    });
  },
  paso4(context) {
    window.fbq("track", "InitiateCheckout", {
      content_type: "Nominas OM",
      content_name: _getCategoria(
        context.state.paquetesBeneficios.caracteristicas
      )
    });
  },
  // TYP
  thankYou(context) {
    window.fbq("track", "Purchase", {
      content_type: "Nominas OM",
      content_name: _getCategoria(
        context.state.paquetesBeneficios.caracteristicas
      )
    });
  },

  /**
   * Pasos del Camino 3 - Cliente
   */
  cliente() {
    window.fbq("track", "Purchase", {
      content_type: "Nominas OM",
      content_name: "CBU"
    });
  },

  /**
   * Pasos del Camino 4 - No Cliente
   */
  noCliente() {
    window.fbq("track", "Purchase", {
      content_type: "Nominas OM",
      content_name: "Sin oferta"
    });
  },

  // Mensajes de error
  sucursal() {
    window.fbq("track", "Lead", {
      content_type: "Nominas OM",
      content_name: "Caja de Ahorro"
    });
  },

  /**
   * Caja de ahorro Emprendedores
   */
  // Landing
  ofertaEmprendedores_consulta() {
    window.fbq("track", "ViewContent", {
      content_type: "Emprendedores"
    });
  },
  // Oferta
  ofertaEmprendedores_oferta(context) {
    /**
     * Si se genera una key, el usuario NO es cliente
     * Entonces puede avanzar con la contratacion
     */
    const key = get(context, "state.key", false);
    if (key) {
      window.fbq("track", "Lead", {
        content_type: "Emprendedores",
        content_name: "NO cliente"
      });
      return;
    }
    window.fbq("track", "Purchase", {
      content_type: "Emprendedores",
      content_name: "cliente"
    });
  },

  /**
   * Caja de Ahorro Suelta
   */
  // Landing
  consulta_ofertaCajaAhorro() {
    window.fbq("track", "ViewContent", {
      content_type: "nomina_cahorro"
    });
  },
  // Oferta
  ofertaCuenta_ofertaCajaAhorro() {
    window.fbq("track", "Terms", {
      content_type: "nomina_cahorro"
    });
  },
  // Mensajes de error
  mensaje_ofertaCajaAhorro(args) {
    const mensaje = get(args, "mutation.payload.params.mje", null);
    switch (mensaje) {
      case RECHAZADO:
      case ERROR_SOLICITUD:
        window.fbq("track", "ErrorProceso", {
          content_type: "nomina_cahorro"
        });
        break;
      default:
        break;
    }
  }

  /*
  ofertaCA() {
    window.fbq("track", "ViewContent", {
      content_type: "Nominas OM",
      content_name: "Caja de Ahorro"
    });
  },
  */
  /*
  thankYouCA() {
    window.fbq("track", "Purchase", {
      content_type: "Nominas OM",
      content_name: "Caja de Ahorro"
    });
  },
  */
};

export default Facebook;
